import { c as _c } from "react/compiler-runtime";
import { useSearchUiPersistStore } from "@/features/search/model/ui/store";
export const useSearch = () => {
  const $ = _c(3);
  const {
    recentSearchKeywordList,
    setRecentSearchKeywordList
  } = useSearchUiPersistStore();
  let t0;
  if ($[0] !== recentSearchKeywordList || $[1] !== setRecentSearchKeywordList) {
    const updateRecentSearchKeywordList = keyword => {
      if (keyword.trim() === "") {
        return;
      }
      const newRecentSearchKeywordList = [keyword, ...recentSearchKeywordList];
      const deduplicationList = [...new Set(newRecentSearchKeywordList)].slice(0, 3);
      setRecentSearchKeywordList(deduplicationList);
    };
    t0 = {
      updateRecentSearchKeywordList
    };
    $[0] = recentSearchKeywordList;
    $[1] = setRecentSearchKeywordList;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};